import type { Question } from '../../data/schemas';
import { generateRandomSeed } from '../shuffle/seededRandom';
import { shuffleOptionsForSession } from '../shuffle/shuffleOptions';
import type { TestSession } from '../../types/session';

/** Erstellt eine neue Test-Session mit frischem Seed und gemischten Antwortreihenfolgen. */
export function createSession(
  questions: readonly Question[],
  schemaVersion: string,
  scoringVersion: string,
): TestSession {
  const now = new Date().toISOString();
  const randomSeed = generateRandomSeed();
  return {
    schemaVersion,
    scoringVersion,
    sessionId: generateRandomSeed(),
    randomSeed,
    createdAt: now,
    updatedAt: now,
    currentStep: 'welcome',
    currentQuestionIndex: 0,
    context: {},
    answers: {},
    optionOrders: shuffleOptionsForSession(questions, randomSeed),
  };
}
